import React, { useEffect, useState } from "react";
import {
  Chip,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { FiltroRepPlano2DTO } from "../../models/controlls.model";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Typography from "@material-ui/core/Typography";

export default function AutoCompleteLocalC(props: autoCompleteLocalCProps) {
  const [operadorSelect, setOperadorSelect] = useState("igual a");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openFilter, setOpenFilter] = useState(false);
  const [value, setValue] = useState<string[]>(
    props.previousValue.length > 0 ? props.previousValue : props.values ?? []
  );
  const campo = props.id.split("-")[0];
  const [blured, setBlured] = useState(false);

  useEffect(() => {
    let obj: string[] = [];
    props.datos.forEach((objeto) => {
      if (value !== null && value.includes(objeto["texto"])) {
        obj.push(objeto["value"]);
      }
    });

    let filtro = {
      campo: campo,
      valor: props.previousValue.length > 0 ? props.previousValue : obj,
      operador: operadorSelect,
      filtro: props.filtro,
      nombreColumna: props.nombreColumna,
    };

    if (Object.keys(props.filtros).length === 0) return;

    props.guardaSeleccion(campo, filtro);
    props.filtros[campo].valor =
      props.previousValue.length > 0 ? props.previousValue : obj;
    props.filtros[campo].operador = operadorSelect;
    props.filtros[campo].nombreColumna = props.nombreColumna;
  }, []);

  useEffect(() => {
    if (value === null || value.length === 0) return;

    let obj: string[] = [];
    props.datos.forEach((objeto) => {
      if (value.includes(objeto["texto"])) {
        obj.push(objeto["value"]);
      }
    });

    let filtro = {
      campo: campo,
      valor: props.previousValue.length > 0 ? props.previousValue : obj,
      operador: operadorSelect,
      filtro: props.filtro,
      nombreColumna: props.nombreColumna,
    };
    if (Object.keys(props.filtros).length === 0) return;

    props.guardaSeleccion(campo, filtro);
    props.filtros[campo].valor =
      props.previousValue.length > 0 ? props.previousValue : obj;
    props.filtros[campo].operador = operadorSelect;
    props.filtros[campo].nombreColumna = props.nombreColumna;
  }, [operadorSelect]);

  function creaFiltro(value: string[]): void {
    let obj: string[] = [];
    props.datos.forEach((objeto) => {
      if (value.includes(objeto["texto"])) {
        obj.push(objeto["value"]);
      }
    });

    props.filtros[campo].valor =
      props.previousValue.length > 0 ? props.previousValue : obj;
    props.filtros[campo].operador = operadorSelect;
    props.filtros[campo].nombreColumna = props.nombreColumna;
  }

  function creaFiltroReporteLocal(value: string[]): any {
    let obj: any[] = [];
    if (props.datos.length === 0) {
      obj = value.map((e) => (isNaN(parseInt(e)) ? e : parseInt(e)));
    } else {
      props.datos.forEach((objeto) => {
        if (value !== null && value.includes(objeto["texto"])) {
          obj.push(objeto["value"]);
        }
      });
    }

    return {
      campo: campo,
      valor: props.previousValue.length > 0 ? props.previousValue : obj,
      operador: operadorSelect,
      filtro: props.filtro,
    };
  }

  const handleClickIco = (event: React.MouseEvent<HTMLButtonElement>) => {
    let element = document.getElementById(
      event.currentTarget.id
    ) as HTMLElement;
    setAnchorEl(element);
    setOpenFilter(true);
  };

  const handleClose =
    (operador: string) => (event: React.MouseEvent<HTMLElement>) => {
      setOpenFilter(false);

      if (operador !== "" && operador !== "eliminar")
        setOperadorSelect(operador);

      if (operador === "eliminar") props.eliminaInput(props.id, props.filtro);

      setAnchorEl(null);
    };

  const validation = (): boolean => {
    return !(!props.error() || !blured || value.length > 0);
  };

  return (
    <Autocomplete
      freeSolo
      style={
        props.graficas
          ? { margin: "0 1%" }
          : props.multiple
          ? props.opciones
            ? { margin: "0 1%" }
            : { margin: "0 1%", width: "100%", minWidth: "200px" }
          : { width: "50%", margin: "0 1%" }
      }
      multiple={props.multiple}
      id={`acl-${props.id}`}
      options={props.datos.map((option) => option.texto)}
      defaultValue={props.values ?? []}
      getOptionLabel={(option) =>
        option === undefined ? "" : option.toString()
      }
      disabled={props.isDisable}
      onChange={(event, value: any[]) => {
        setValue(value);

        if (Object.keys(props.filtros).length > 0) creaFiltro(value);
        else props.guardaSeleccion(campo, creaFiltroReporteLocal(value));
      }}
      renderOption={(option) => (
        <Typography style={{ fontSize: "13px" }}>{`${option}`}</Typography>
      )}
      renderTags={(value: string[], getTagProps) =>
        value.map((option: string, index: number) => (
          <Chip
            key={`chip-${campo}-${index}`}
            variant="outlined"
            label={option}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          color="primary"
          label={campo}
          variant="standard"
          style={{ fontSize: "13px" }}
          error={validation()}
          helperText={validation() ? props.labelError : ""}
          onBlur={() => setBlured(true)}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {!props.onlySentence && props.multiple && props.opciones ? (
                  <>
                    <Tooltip title={operadorSelect}>
                      <IconButton
                        id={`ico-${campo}`}
                        aria-label="more"
                        aria-controls="long-menu"
                        aria-haspopup="true"
                        onClick={handleClickIco}
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      id={`menu-${campo}`}
                      anchorEl={anchorEl}
                      keepMounted
                      open={openFilter}
                      onClose={handleClose("")}
                    >
                      {!props.error() ? (
                        <MenuItem
                          id={`subME-${campo}`}
                          onClick={handleClose("eliminar")}
                        >
                          eliminar
                        </MenuItem>
                      ) : null}
                      <MenuItem
                        id={`subM1-${campo}`}
                        onClick={handleClose("igual a")}
                      >
                        igual a
                      </MenuItem>
                      <MenuItem
                        id={`subM2-${campo}`}
                        onClick={handleClose("contiene")}
                      >
                        contiene
                      </MenuItem>
                      <MenuItem
                        id={`subM3-${campo}`}
                        onClick={handleClose("diferente")}
                      >
                        diferente
                      </MenuItem>
                    </Menu>
                  </>
                ) : null}
              </React.Fragment>
            ),
          }}
          InputLabelProps={{
            ...params.InputLabelProps,
          }}
        />
      )}
    />
  );
}

interface autoCompleteLocalCProps {
  id: string;
  filtro: boolean;
  filtros: any;
  datos: any[];
  multiple: boolean;
  opciones: boolean;
  graficas: boolean;
  values: string[];
  previousValue: any[];
  nombreColumna: string;
  error(): boolean;
  labelError: string;
  onlySentence: boolean;
  isDisable: boolean;
  eliminaInput(idCampo: string, filtroInput: boolean): void;
  guardaSeleccion(campo: string, filtro: FiltroRepPlano2DTO): void;
}

AutoCompleteLocalC.defaultProps = {
  multiple: true,
  values: [],
  opciones: true,
  graficas: false,
  error: () => false,
  onlySentence: false,
  labelError: "Campo requerido.",
  nombreColumna: "",
  isDisable: false,
  previousValue: [],
};
